import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";

export interface ErrorPayload {
  message: string;
  id?: string;
}

const initialState: Array<ErrorPayload> = [];

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<ErrorPayload>) => {
      const toastWithSameMessage = state.find(
        (item) => item.message === action.payload.message
      );

      if (toastWithSameMessage) {
        return state;
      } else {
        return [...state, { ...action.payload, id: uuid() }];
      }
    },
    remove: (state, action: PayloadAction<string>) => {
      return state.filter((error) => error.id !== action.payload);
    },
  },
});

export const { add, remove } = errorsSlice.actions;
export default errorsSlice.reducer;
